<button mat-icon-button class="notifications-button grow" [matMenuTriggerFor]="notification_menu">
  <mat-icon
    [ngClass]="{ 'bounce': getNotificationsCount() !== '0' && getNotificationsCount() !== null }"
    class="notification-container"
    matBadgeSize="small"
    [matBadge]="getNotificationsCount()"
    [matBadgeHidden]="getNotificationsCount() === '0' || getNotificationsCount() === null"
    matBadgePosition="below after"
    >notifications</mat-icon
  >
</button>

<mat-menu class="notification-menu" #notification_menu="matMenu">
  <header id="head" class="notification-header">Notifications</header>
  <h5 class="only-unread">Only show unread</h5>
  <label class="switch" (click)="unreadToggle($event)">
    <input type="checkbox" />
    <div class="slider round"></div>
  </label>
  <!-- <a routerLink="/notifications">
    <mat-icon class="open-in-new" title="Expanded notification view">
      open_in_new</mat-icon
    >
  </a> -->
  <hr class="break-line" />
  <div class="markAll">
    <h5 class="mark-read" (click)="markAllRead($event)">Mark all as read</h5>
  </div>
  <h5 *ngIf="getNotificationsCount() === null" class="empty-state-message">
    No notifications to view
  </h5>
  <app-notifications [notifications]="notifications" *ngIf="getNotificationsCount() !== null">
  </app-notifications>
</mat-menu>
